/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Views_SharedInputs */

const en_views_shared = /** @type {(inputs: Views_SharedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shared`)
};

const de_views_shared = /** @type {(inputs: Views_SharedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geteilt`)
};

/**
* | output |
* | --- |
* | "Shared" |
*
* @param {Views_SharedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const views_shared = /** @type {((inputs?: Views_SharedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Views_SharedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_views_shared(inputs)
	return en_views_shared(inputs)
});